/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VehiclesRouteImport } from './routes/vehicles'
import { Route as UnexpectedEventsRouteImport } from './routes/unexpected-events'
import { Route as ShiftsRouteImport } from './routes/shifts'
import { Route as SchedulingRouteImport } from './routes/scheduling'
import { Route as RoutesRouteImport } from './routes/routes'
import { Route as RouteStatisticsRouteImport } from './routes/route-statistics'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HotlineCallsRouteImport } from './routes/hotline-calls'
import { Route as DriversRouteImport } from './routes/drivers'
import { Route as DriverStatisticsRouteImport } from './routes/driver-statistics'
import { Route as DriveStatisticsRouteImport } from './routes/drive-statistics'
import { Route as DriveDetailsRouteImport } from './routes/drive-details'
import { Route as ControlDataRouteImport } from './routes/control-data'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as CarNavigationRouteImport } from './routes/car-navigation'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UnexpectedEventsEventIdRouteImport } from './routes/unexpected-events.$eventId'
import { Route as DriversFilterRouteImport } from './routes/drivers.$filter'
import { Route as DriveDetailsIdRouteImport } from './routes/drive-details.$id'
import { Route as CarNavigationSourceRouteImport } from './routes/car-navigation.$source'
import { Route as ShiftsStartDateEndDateRouteImport } from './routes/shifts.$startDate.$endDate'
import { Route as SchedulingStartDateEndDateRouteImport } from './routes/scheduling.$startDate.$endDate'
import { Route as RouteRouteIdVersionRouteImport } from './routes/route.$routeId.$version'
import { Route as RouteStatisticsStartDateEndDateRouteImport } from './routes/route-statistics.$startDate.$endDate'
import { Route as HotlineCallsStartDateEndDateRouteImport } from './routes/hotline-calls.$startDate.$endDate'
import { Route as HardwareSourceTabRouteImport } from './routes/hardware.$source.$tab'
import { Route as DriverStatisticsStartDateEndDateRouteImport } from './routes/driver-statistics.$startDate.$endDate'
import { Route as DriveStatisticsStartDateEndDateRouteImport } from './routes/drive-statistics.$startDate.$endDate'
import { Route as SchedulingStartDateEndDateErrorRouteImport } from './routes/scheduling.$startDate.$endDate.error'
import { Route as SchedulingStartDateEndDateDriveActionIdRouteImport } from './routes/scheduling.$startDate.$endDate.drive.$action.$id'

const VehiclesRoute = VehiclesRouteImport.update({
  id: '/vehicles',
  path: '/vehicles',
  getParentRoute: () => rootRouteImport,
} as any)
const UnexpectedEventsRoute = UnexpectedEventsRouteImport.update({
  id: '/unexpected-events',
  path: '/unexpected-events',
  getParentRoute: () => rootRouteImport,
} as any)
const ShiftsRoute = ShiftsRouteImport.update({
  id: '/shifts',
  path: '/shifts',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulingRoute = SchedulingRouteImport.update({
  id: '/scheduling',
  path: '/scheduling',
  getParentRoute: () => rootRouteImport,
} as any)
const RoutesRoute = RoutesRouteImport.update({
  id: '/routes',
  path: '/routes',
  getParentRoute: () => rootRouteImport,
} as any)
const RouteStatisticsRoute = RouteStatisticsRouteImport.update({
  id: '/route-statistics',
  path: '/route-statistics',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HotlineCallsRoute = HotlineCallsRouteImport.update({
  id: '/hotline-calls',
  path: '/hotline-calls',
  getParentRoute: () => rootRouteImport,
} as any)
const DriversRoute = DriversRouteImport.update({
  id: '/drivers',
  path: '/drivers',
  getParentRoute: () => rootRouteImport,
} as any)
const DriverStatisticsRoute = DriverStatisticsRouteImport.update({
  id: '/driver-statistics',
  path: '/driver-statistics',
  getParentRoute: () => rootRouteImport,
} as any)
const DriveStatisticsRoute = DriveStatisticsRouteImport.update({
  id: '/drive-statistics',
  path: '/drive-statistics',
  getParentRoute: () => rootRouteImport,
} as any)
const DriveDetailsRoute = DriveDetailsRouteImport.update({
  id: '/drive-details',
  path: '/drive-details',
  getParentRoute: () => rootRouteImport,
} as any)
const ControlDataRoute = ControlDataRouteImport.update({
  id: '/control-data',
  path: '/control-data',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CarNavigationRoute = CarNavigationRouteImport.update({
  id: '/car-navigation',
  path: '/car-navigation',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UnexpectedEventsEventIdRoute = UnexpectedEventsEventIdRouteImport.update({
  id: '/$eventId',
  path: '/$eventId',
  getParentRoute: () => UnexpectedEventsRoute,
} as any)
const DriversFilterRoute = DriversFilterRouteImport.update({
  id: '/$filter',
  path: '/$filter',
  getParentRoute: () => DriversRoute,
} as any)
const DriveDetailsIdRoute = DriveDetailsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DriveDetailsRoute,
} as any)
const CarNavigationSourceRoute = CarNavigationSourceRouteImport.update({
  id: '/$source',
  path: '/$source',
  getParentRoute: () => CarNavigationRoute,
} as any)
const ShiftsStartDateEndDateRoute = ShiftsStartDateEndDateRouteImport.update({
  id: '/$startDate/$endDate',
  path: '/$startDate/$endDate',
  getParentRoute: () => ShiftsRoute,
} as any)
const SchedulingStartDateEndDateRoute = SchedulingStartDateEndDateRouteImport.update({
  id: '/$startDate/$endDate',
  path: '/$startDate/$endDate',
  getParentRoute: () => SchedulingRoute,
} as any)
const RouteRouteIdVersionRoute = RouteRouteIdVersionRouteImport.update({
  id: '/route/$routeId/$version',
  path: '/route/$routeId/$version',
  getParentRoute: () => rootRouteImport,
} as any)
const RouteStatisticsStartDateEndDateRoute = RouteStatisticsStartDateEndDateRouteImport.update({
  id: '/$startDate/$endDate',
  path: '/$startDate/$endDate',
  getParentRoute: () => RouteStatisticsRoute,
} as any)
const HotlineCallsStartDateEndDateRoute = HotlineCallsStartDateEndDateRouteImport.update({
  id: '/$startDate/$endDate',
  path: '/$startDate/$endDate',
  getParentRoute: () => HotlineCallsRoute,
} as any)
const HardwareSourceTabRoute = HardwareSourceTabRouteImport.update({
  id: '/hardware/$source/$tab',
  path: '/hardware/$source/$tab',
  getParentRoute: () => rootRouteImport,
} as any)
const DriverStatisticsStartDateEndDateRoute = DriverStatisticsStartDateEndDateRouteImport.update({
  id: '/$startDate/$endDate',
  path: '/$startDate/$endDate',
  getParentRoute: () => DriverStatisticsRoute,
} as any)
const DriveStatisticsStartDateEndDateRoute = DriveStatisticsStartDateEndDateRouteImport.update({
  id: '/$startDate/$endDate',
  path: '/$startDate/$endDate',
  getParentRoute: () => DriveStatisticsRoute,
} as any)
const SchedulingStartDateEndDateErrorRoute = SchedulingStartDateEndDateErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => SchedulingStartDateEndDateRoute,
} as any)
const SchedulingStartDateEndDateDriveActionIdRoute = SchedulingStartDateEndDateDriveActionIdRouteImport.update({
  id: '/drive/$action/$id',
  path: '/drive/$action/$id',
  getParentRoute: () => SchedulingStartDateEndDateRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/car-navigation': typeof CarNavigationRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/control-data': typeof ControlDataRoute
  '/drive-details': typeof DriveDetailsRouteWithChildren
  '/drive-statistics': typeof DriveStatisticsRouteWithChildren
  '/driver-statistics': typeof DriverStatisticsRouteWithChildren
  '/drivers': typeof DriversRouteWithChildren
  '/hotline-calls': typeof HotlineCallsRouteWithChildren
  '/login': typeof LoginRoute
  '/route-statistics': typeof RouteStatisticsRouteWithChildren
  '/routes': typeof RoutesRoute
  '/scheduling': typeof SchedulingRouteWithChildren
  '/shifts': typeof ShiftsRouteWithChildren
  '/unexpected-events': typeof UnexpectedEventsRouteWithChildren
  '/vehicles': typeof VehiclesRoute
  '/car-navigation/$source': typeof CarNavigationSourceRoute
  '/drive-details/$id': typeof DriveDetailsIdRoute
  '/drivers/$filter': typeof DriversFilterRoute
  '/unexpected-events/$eventId': typeof UnexpectedEventsEventIdRoute
  '/drive-statistics/$startDate/$endDate': typeof DriveStatisticsStartDateEndDateRoute
  '/driver-statistics/$startDate/$endDate': typeof DriverStatisticsStartDateEndDateRoute
  '/hardware/$source/$tab': typeof HardwareSourceTabRoute
  '/hotline-calls/$startDate/$endDate': typeof HotlineCallsStartDateEndDateRoute
  '/route-statistics/$startDate/$endDate': typeof RouteStatisticsStartDateEndDateRoute
  '/route/$routeId/$version': typeof RouteRouteIdVersionRoute
  '/scheduling/$startDate/$endDate': typeof SchedulingStartDateEndDateRouteWithChildren
  '/shifts/$startDate/$endDate': typeof ShiftsStartDateEndDateRoute
  '/scheduling/$startDate/$endDate/error': typeof SchedulingStartDateEndDateErrorRoute
  '/scheduling/$startDate/$endDate/drive/$action/$id': typeof SchedulingStartDateEndDateDriveActionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/car-navigation': typeof CarNavigationRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/control-data': typeof ControlDataRoute
  '/drive-details': typeof DriveDetailsRouteWithChildren
  '/drive-statistics': typeof DriveStatisticsRouteWithChildren
  '/driver-statistics': typeof DriverStatisticsRouteWithChildren
  '/drivers': typeof DriversRouteWithChildren
  '/hotline-calls': typeof HotlineCallsRouteWithChildren
  '/login': typeof LoginRoute
  '/route-statistics': typeof RouteStatisticsRouteWithChildren
  '/routes': typeof RoutesRoute
  '/scheduling': typeof SchedulingRouteWithChildren
  '/shifts': typeof ShiftsRouteWithChildren
  '/unexpected-events': typeof UnexpectedEventsRouteWithChildren
  '/vehicles': typeof VehiclesRoute
  '/car-navigation/$source': typeof CarNavigationSourceRoute
  '/drive-details/$id': typeof DriveDetailsIdRoute
  '/drivers/$filter': typeof DriversFilterRoute
  '/unexpected-events/$eventId': typeof UnexpectedEventsEventIdRoute
  '/drive-statistics/$startDate/$endDate': typeof DriveStatisticsStartDateEndDateRoute
  '/driver-statistics/$startDate/$endDate': typeof DriverStatisticsStartDateEndDateRoute
  '/hardware/$source/$tab': typeof HardwareSourceTabRoute
  '/hotline-calls/$startDate/$endDate': typeof HotlineCallsStartDateEndDateRoute
  '/route-statistics/$startDate/$endDate': typeof RouteStatisticsStartDateEndDateRoute
  '/route/$routeId/$version': typeof RouteRouteIdVersionRoute
  '/scheduling/$startDate/$endDate': typeof SchedulingStartDateEndDateRouteWithChildren
  '/shifts/$startDate/$endDate': typeof ShiftsStartDateEndDateRoute
  '/scheduling/$startDate/$endDate/error': typeof SchedulingStartDateEndDateErrorRoute
  '/scheduling/$startDate/$endDate/drive/$action/$id': typeof SchedulingStartDateEndDateDriveActionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/car-navigation': typeof CarNavigationRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/control-data': typeof ControlDataRoute
  '/drive-details': typeof DriveDetailsRouteWithChildren
  '/drive-statistics': typeof DriveStatisticsRouteWithChildren
  '/driver-statistics': typeof DriverStatisticsRouteWithChildren
  '/drivers': typeof DriversRouteWithChildren
  '/hotline-calls': typeof HotlineCallsRouteWithChildren
  '/login': typeof LoginRoute
  '/route-statistics': typeof RouteStatisticsRouteWithChildren
  '/routes': typeof RoutesRoute
  '/scheduling': typeof SchedulingRouteWithChildren
  '/shifts': typeof ShiftsRouteWithChildren
  '/unexpected-events': typeof UnexpectedEventsRouteWithChildren
  '/vehicles': typeof VehiclesRoute
  '/car-navigation/$source': typeof CarNavigationSourceRoute
  '/drive-details/$id': typeof DriveDetailsIdRoute
  '/drivers/$filter': typeof DriversFilterRoute
  '/unexpected-events/$eventId': typeof UnexpectedEventsEventIdRoute
  '/drive-statistics/$startDate/$endDate': typeof DriveStatisticsStartDateEndDateRoute
  '/driver-statistics/$startDate/$endDate': typeof DriverStatisticsStartDateEndDateRoute
  '/hardware/$source/$tab': typeof HardwareSourceTabRoute
  '/hotline-calls/$startDate/$endDate': typeof HotlineCallsStartDateEndDateRoute
  '/route-statistics/$startDate/$endDate': typeof RouteStatisticsStartDateEndDateRoute
  '/route/$routeId/$version': typeof RouteRouteIdVersionRoute
  '/scheduling/$startDate/$endDate': typeof SchedulingStartDateEndDateRouteWithChildren
  '/shifts/$startDate/$endDate': typeof ShiftsStartDateEndDateRoute
  '/scheduling/$startDate/$endDate/error': typeof SchedulingStartDateEndDateErrorRoute
  '/scheduling/$startDate/$endDate/drive/$action/$id': typeof SchedulingStartDateEndDateDriveActionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/car-navigation'
    | '/change-password'
    | '/control-data'
    | '/drive-details'
    | '/drive-statistics'
    | '/driver-statistics'
    | '/drivers'
    | '/hotline-calls'
    | '/login'
    | '/route-statistics'
    | '/routes'
    | '/scheduling'
    | '/shifts'
    | '/unexpected-events'
    | '/vehicles'
    | '/car-navigation/$source'
    | '/drive-details/$id'
    | '/drivers/$filter'
    | '/unexpected-events/$eventId'
    | '/drive-statistics/$startDate/$endDate'
    | '/driver-statistics/$startDate/$endDate'
    | '/hardware/$source/$tab'
    | '/hotline-calls/$startDate/$endDate'
    | '/route-statistics/$startDate/$endDate'
    | '/route/$routeId/$version'
    | '/scheduling/$startDate/$endDate'
    | '/shifts/$startDate/$endDate'
    | '/scheduling/$startDate/$endDate/error'
    | '/scheduling/$startDate/$endDate/drive/$action/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/car-navigation'
    | '/change-password'
    | '/control-data'
    | '/drive-details'
    | '/drive-statistics'
    | '/driver-statistics'
    | '/drivers'
    | '/hotline-calls'
    | '/login'
    | '/route-statistics'
    | '/routes'
    | '/scheduling'
    | '/shifts'
    | '/unexpected-events'
    | '/vehicles'
    | '/car-navigation/$source'
    | '/drive-details/$id'
    | '/drivers/$filter'
    | '/unexpected-events/$eventId'
    | '/drive-statistics/$startDate/$endDate'
    | '/driver-statistics/$startDate/$endDate'
    | '/hardware/$source/$tab'
    | '/hotline-calls/$startDate/$endDate'
    | '/route-statistics/$startDate/$endDate'
    | '/route/$routeId/$version'
    | '/scheduling/$startDate/$endDate'
    | '/shifts/$startDate/$endDate'
    | '/scheduling/$startDate/$endDate/error'
    | '/scheduling/$startDate/$endDate/drive/$action/$id'
  id:
    | '__root__'
    | '/'
    | '/car-navigation'
    | '/change-password'
    | '/control-data'
    | '/drive-details'
    | '/drive-statistics'
    | '/driver-statistics'
    | '/drivers'
    | '/hotline-calls'
    | '/login'
    | '/route-statistics'
    | '/routes'
    | '/scheduling'
    | '/shifts'
    | '/unexpected-events'
    | '/vehicles'
    | '/car-navigation/$source'
    | '/drive-details/$id'
    | '/drivers/$filter'
    | '/unexpected-events/$eventId'
    | '/drive-statistics/$startDate/$endDate'
    | '/driver-statistics/$startDate/$endDate'
    | '/hardware/$source/$tab'
    | '/hotline-calls/$startDate/$endDate'
    | '/route-statistics/$startDate/$endDate'
    | '/route/$routeId/$version'
    | '/scheduling/$startDate/$endDate'
    | '/shifts/$startDate/$endDate'
    | '/scheduling/$startDate/$endDate/error'
    | '/scheduling/$startDate/$endDate/drive/$action/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CarNavigationRoute: typeof CarNavigationRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  ControlDataRoute: typeof ControlDataRoute
  DriveDetailsRoute: typeof DriveDetailsRouteWithChildren
  DriveStatisticsRoute: typeof DriveStatisticsRouteWithChildren
  DriverStatisticsRoute: typeof DriverStatisticsRouteWithChildren
  DriversRoute: typeof DriversRouteWithChildren
  HotlineCallsRoute: typeof HotlineCallsRouteWithChildren
  LoginRoute: typeof LoginRoute
  RouteStatisticsRoute: typeof RouteStatisticsRouteWithChildren
  RoutesRoute: typeof RoutesRoute
  SchedulingRoute: typeof SchedulingRouteWithChildren
  ShiftsRoute: typeof ShiftsRouteWithChildren
  UnexpectedEventsRoute: typeof UnexpectedEventsRouteWithChildren
  VehiclesRoute: typeof VehiclesRoute
  HardwareSourceTabRoute: typeof HardwareSourceTabRoute
  RouteRouteIdVersionRoute: typeof RouteRouteIdVersionRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vehicles': {
      id: '/vehicles'
      path: '/vehicles'
      fullPath: '/vehicles'
      preLoaderRoute: typeof VehiclesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unexpected-events': {
      id: '/unexpected-events'
      path: '/unexpected-events'
      fullPath: '/unexpected-events'
      preLoaderRoute: typeof UnexpectedEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shifts': {
      id: '/shifts'
      path: '/shifts'
      fullPath: '/shifts'
      preLoaderRoute: typeof ShiftsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduling': {
      id: '/scheduling'
      path: '/scheduling'
      fullPath: '/scheduling'
      preLoaderRoute: typeof SchedulingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/routes': {
      id: '/routes'
      path: '/routes'
      fullPath: '/routes'
      preLoaderRoute: typeof RoutesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/route-statistics': {
      id: '/route-statistics'
      path: '/route-statistics'
      fullPath: '/route-statistics'
      preLoaderRoute: typeof RouteStatisticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hotline-calls': {
      id: '/hotline-calls'
      path: '/hotline-calls'
      fullPath: '/hotline-calls'
      preLoaderRoute: typeof HotlineCallsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/drivers': {
      id: '/drivers'
      path: '/drivers'
      fullPath: '/drivers'
      preLoaderRoute: typeof DriversRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/driver-statistics': {
      id: '/driver-statistics'
      path: '/driver-statistics'
      fullPath: '/driver-statistics'
      preLoaderRoute: typeof DriverStatisticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/drive-statistics': {
      id: '/drive-statistics'
      path: '/drive-statistics'
      fullPath: '/drive-statistics'
      preLoaderRoute: typeof DriveStatisticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/drive-details': {
      id: '/drive-details'
      path: '/drive-details'
      fullPath: '/drive-details'
      preLoaderRoute: typeof DriveDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/control-data': {
      id: '/control-data'
      path: '/control-data'
      fullPath: '/control-data'
      preLoaderRoute: typeof ControlDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/car-navigation': {
      id: '/car-navigation'
      path: '/car-navigation'
      fullPath: '/car-navigation'
      preLoaderRoute: typeof CarNavigationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unexpected-events/$eventId': {
      id: '/unexpected-events/$eventId'
      path: '/$eventId'
      fullPath: '/unexpected-events/$eventId'
      preLoaderRoute: typeof UnexpectedEventsEventIdRouteImport
      parentRoute: typeof UnexpectedEventsRoute
    }
    '/drivers/$filter': {
      id: '/drivers/$filter'
      path: '/$filter'
      fullPath: '/drivers/$filter'
      preLoaderRoute: typeof DriversFilterRouteImport
      parentRoute: typeof DriversRoute
    }
    '/drive-details/$id': {
      id: '/drive-details/$id'
      path: '/$id'
      fullPath: '/drive-details/$id'
      preLoaderRoute: typeof DriveDetailsIdRouteImport
      parentRoute: typeof DriveDetailsRoute
    }
    '/car-navigation/$source': {
      id: '/car-navigation/$source'
      path: '/$source'
      fullPath: '/car-navigation/$source'
      preLoaderRoute: typeof CarNavigationSourceRouteImport
      parentRoute: typeof CarNavigationRoute
    }
    '/shifts/$startDate/$endDate': {
      id: '/shifts/$startDate/$endDate'
      path: '/$startDate/$endDate'
      fullPath: '/shifts/$startDate/$endDate'
      preLoaderRoute: typeof ShiftsStartDateEndDateRouteImport
      parentRoute: typeof ShiftsRoute
    }
    '/scheduling/$startDate/$endDate': {
      id: '/scheduling/$startDate/$endDate'
      path: '/$startDate/$endDate'
      fullPath: '/scheduling/$startDate/$endDate'
      preLoaderRoute: typeof SchedulingStartDateEndDateRouteImport
      parentRoute: typeof SchedulingRoute
    }
    '/route/$routeId/$version': {
      id: '/route/$routeId/$version'
      path: '/route/$routeId/$version'
      fullPath: '/route/$routeId/$version'
      preLoaderRoute: typeof RouteRouteIdVersionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/route-statistics/$startDate/$endDate': {
      id: '/route-statistics/$startDate/$endDate'
      path: '/$startDate/$endDate'
      fullPath: '/route-statistics/$startDate/$endDate'
      preLoaderRoute: typeof RouteStatisticsStartDateEndDateRouteImport
      parentRoute: typeof RouteStatisticsRoute
    }
    '/hotline-calls/$startDate/$endDate': {
      id: '/hotline-calls/$startDate/$endDate'
      path: '/$startDate/$endDate'
      fullPath: '/hotline-calls/$startDate/$endDate'
      preLoaderRoute: typeof HotlineCallsStartDateEndDateRouteImport
      parentRoute: typeof HotlineCallsRoute
    }
    '/hardware/$source/$tab': {
      id: '/hardware/$source/$tab'
      path: '/hardware/$source/$tab'
      fullPath: '/hardware/$source/$tab'
      preLoaderRoute: typeof HardwareSourceTabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/driver-statistics/$startDate/$endDate': {
      id: '/driver-statistics/$startDate/$endDate'
      path: '/$startDate/$endDate'
      fullPath: '/driver-statistics/$startDate/$endDate'
      preLoaderRoute: typeof DriverStatisticsStartDateEndDateRouteImport
      parentRoute: typeof DriverStatisticsRoute
    }
    '/drive-statistics/$startDate/$endDate': {
      id: '/drive-statistics/$startDate/$endDate'
      path: '/$startDate/$endDate'
      fullPath: '/drive-statistics/$startDate/$endDate'
      preLoaderRoute: typeof DriveStatisticsStartDateEndDateRouteImport
      parentRoute: typeof DriveStatisticsRoute
    }
    '/scheduling/$startDate/$endDate/error': {
      id: '/scheduling/$startDate/$endDate/error'
      path: '/error'
      fullPath: '/scheduling/$startDate/$endDate/error'
      preLoaderRoute: typeof SchedulingStartDateEndDateErrorRouteImport
      parentRoute: typeof SchedulingStartDateEndDateRoute
    }
    '/scheduling/$startDate/$endDate/drive/$action/$id': {
      id: '/scheduling/$startDate/$endDate/drive/$action/$id'
      path: '/drive/$action/$id'
      fullPath: '/scheduling/$startDate/$endDate/drive/$action/$id'
      preLoaderRoute: typeof SchedulingStartDateEndDateDriveActionIdRouteImport
      parentRoute: typeof SchedulingStartDateEndDateRoute
    }
  }
}

interface CarNavigationRouteChildren {
  CarNavigationSourceRoute: typeof CarNavigationSourceRoute
}

const CarNavigationRouteChildren: CarNavigationRouteChildren = {
  CarNavigationSourceRoute: CarNavigationSourceRoute,
}

const CarNavigationRouteWithChildren = CarNavigationRoute._addFileChildren(CarNavigationRouteChildren)

interface DriveDetailsRouteChildren {
  DriveDetailsIdRoute: typeof DriveDetailsIdRoute
}

const DriveDetailsRouteChildren: DriveDetailsRouteChildren = {
  DriveDetailsIdRoute: DriveDetailsIdRoute,
}

const DriveDetailsRouteWithChildren = DriveDetailsRoute._addFileChildren(DriveDetailsRouteChildren)

interface DriveStatisticsRouteChildren {
  DriveStatisticsStartDateEndDateRoute: typeof DriveStatisticsStartDateEndDateRoute
}

const DriveStatisticsRouteChildren: DriveStatisticsRouteChildren = {
  DriveStatisticsStartDateEndDateRoute: DriveStatisticsStartDateEndDateRoute,
}

const DriveStatisticsRouteWithChildren = DriveStatisticsRoute._addFileChildren(DriveStatisticsRouteChildren)

interface DriverStatisticsRouteChildren {
  DriverStatisticsStartDateEndDateRoute: typeof DriverStatisticsStartDateEndDateRoute
}

const DriverStatisticsRouteChildren: DriverStatisticsRouteChildren = {
  DriverStatisticsStartDateEndDateRoute: DriverStatisticsStartDateEndDateRoute,
}

const DriverStatisticsRouteWithChildren = DriverStatisticsRoute._addFileChildren(DriverStatisticsRouteChildren)

interface DriversRouteChildren {
  DriversFilterRoute: typeof DriversFilterRoute
}

const DriversRouteChildren: DriversRouteChildren = {
  DriversFilterRoute: DriversFilterRoute,
}

const DriversRouteWithChildren = DriversRoute._addFileChildren(DriversRouteChildren)

interface HotlineCallsRouteChildren {
  HotlineCallsStartDateEndDateRoute: typeof HotlineCallsStartDateEndDateRoute
}

const HotlineCallsRouteChildren: HotlineCallsRouteChildren = {
  HotlineCallsStartDateEndDateRoute: HotlineCallsStartDateEndDateRoute,
}

const HotlineCallsRouteWithChildren = HotlineCallsRoute._addFileChildren(HotlineCallsRouteChildren)

interface RouteStatisticsRouteChildren {
  RouteStatisticsStartDateEndDateRoute: typeof RouteStatisticsStartDateEndDateRoute
}

const RouteStatisticsRouteChildren: RouteStatisticsRouteChildren = {
  RouteStatisticsStartDateEndDateRoute: RouteStatisticsStartDateEndDateRoute,
}

const RouteStatisticsRouteWithChildren = RouteStatisticsRoute._addFileChildren(RouteStatisticsRouteChildren)

interface SchedulingStartDateEndDateRouteChildren {
  SchedulingStartDateEndDateErrorRoute: typeof SchedulingStartDateEndDateErrorRoute
  SchedulingStartDateEndDateDriveActionIdRoute: typeof SchedulingStartDateEndDateDriveActionIdRoute
}

const SchedulingStartDateEndDateRouteChildren: SchedulingStartDateEndDateRouteChildren = {
  SchedulingStartDateEndDateErrorRoute: SchedulingStartDateEndDateErrorRoute,
  SchedulingStartDateEndDateDriveActionIdRoute: SchedulingStartDateEndDateDriveActionIdRoute,
}

const SchedulingStartDateEndDateRouteWithChildren = SchedulingStartDateEndDateRoute._addFileChildren(
  SchedulingStartDateEndDateRouteChildren
)

interface SchedulingRouteChildren {
  SchedulingStartDateEndDateRoute: typeof SchedulingStartDateEndDateRouteWithChildren
}

const SchedulingRouteChildren: SchedulingRouteChildren = {
  SchedulingStartDateEndDateRoute: SchedulingStartDateEndDateRouteWithChildren,
}

const SchedulingRouteWithChildren = SchedulingRoute._addFileChildren(SchedulingRouteChildren)

interface ShiftsRouteChildren {
  ShiftsStartDateEndDateRoute: typeof ShiftsStartDateEndDateRoute
}

const ShiftsRouteChildren: ShiftsRouteChildren = {
  ShiftsStartDateEndDateRoute: ShiftsStartDateEndDateRoute,
}

const ShiftsRouteWithChildren = ShiftsRoute._addFileChildren(ShiftsRouteChildren)

interface UnexpectedEventsRouteChildren {
  UnexpectedEventsEventIdRoute: typeof UnexpectedEventsEventIdRoute
}

const UnexpectedEventsRouteChildren: UnexpectedEventsRouteChildren = {
  UnexpectedEventsEventIdRoute: UnexpectedEventsEventIdRoute,
}

const UnexpectedEventsRouteWithChildren = UnexpectedEventsRoute._addFileChildren(UnexpectedEventsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CarNavigationRoute: CarNavigationRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  ControlDataRoute: ControlDataRoute,
  DriveDetailsRoute: DriveDetailsRouteWithChildren,
  DriveStatisticsRoute: DriveStatisticsRouteWithChildren,
  DriverStatisticsRoute: DriverStatisticsRouteWithChildren,
  DriversRoute: DriversRouteWithChildren,
  HotlineCallsRoute: HotlineCallsRouteWithChildren,
  LoginRoute: LoginRoute,
  RouteStatisticsRoute: RouteStatisticsRouteWithChildren,
  RoutesRoute: RoutesRoute,
  SchedulingRoute: SchedulingRouteWithChildren,
  ShiftsRoute: ShiftsRouteWithChildren,
  UnexpectedEventsRoute: UnexpectedEventsRouteWithChildren,
  VehiclesRoute: VehiclesRoute,
  HardwareSourceTabRoute: HardwareSourceTabRoute,
  RouteRouteIdVersionRoute: RouteRouteIdVersionRoute,
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)._addFileTypes<FileRouteTypes>()
